import $ from 'jquery';
import {Alpine} from 'alpinejs';

window.Alpine = Alpine;

$(() => {
  //setTimeout(showpanel, 2000) //set the delay time
  Alpine.start();

  $('.content_close img').on('click', function () {
    setCookie(GrootPopup.cookieName, 1, 1);
    setCounterCookie();
  });
  $('.content_cta').on('click', function () {
    setCookie(GrootPopup.cookieName, 1, 1);
    setCounterCookie();
  });
  $('.content_newsletter .mc4wp-form button[type="submit"]').on('click', function () {
    setCookie(GrootPopup.cookieName, 1, 1);
    setCounterCookie();
  });
});

function setCookie(name, value, expiration_days)
{
  let date = new Date();
  date.setTime(date.getTime() + (expiration_days * 24 * 60 * 60 * 1000));
  let expires = 'expires=' + date.toUTCString();

  document.cookie = name + '=' + value + '; ' + expires + ';path=/';
}

function setCounterCookie()
{
  const timerCookie = getCookie(GrootPopup.cookieCounterName);

  if (timerCookie === null) {
    setCookie(GrootPopup.cookieCounterName, 1, 1);
  } else {
    setCookie(GrootPopup.cookieCounterName, parseInt(timerCookie) + 1, 1);
  }
}

function getCookie(name)
{
  const cookies = document.cookie;
  const prefix = name + '=';
  let begin = cookies.indexOf('; ' + prefix);

  if (begin === -1) {
    begin = cookies.indexOf(prefix);
    if (begin !== 0) {
      return null;
    }
  } else {
    begin += 2;
    let end = cookies.indexOf(';', begin);
    if (end === -1) {
      end = cookies.length;
    }
    return decodeURI(cookies.substring(begin + prefix.length, end));
  }
}
